import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';

const path = '/analytics/datadog-shared-dashboards';
const url = `${OCTOPUS_BASE_URL}${path}`;

export const getDatadogSharedDashboards = () => axios.get(url);
